export enum PostType {
  COMMON = 'common',
  EVENT_NOTIFICATION = 'event',
  SYSTEM_NOTIFICATION = 'system_notification',
  VIDEO = 'video',
  VOICE = 'voice',
}
